module.exports = __webpack_public_path__ + "img/4.583fa641.jpg";